// extracted by mini-css-extract-plugin
export default {"popoverContent":"BudgetLimitTypePopover_popoverContent__0r7Y1"};